/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `Etappe`
};

const en_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `step`
};

const es_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `escala`
};

const fr_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `étape`
};

const it_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `tappa`
};

const nl_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `tussenstop`
};

const pt_route__step = /** @type {(inputs: {}) => string} */ () => {
	return `etapa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__step = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__step(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__step", locale)
	if (locale === "de") return de_route__step(inputs)
	if (locale === "en") return en_route__step(inputs)
	if (locale === "es") return es_route__step(inputs)
	if (locale === "fr") return fr_route__step(inputs)
	if (locale === "it") return it_route__step(inputs)
	if (locale === "nl") return nl_route__step(inputs)
	return pt_route__step(inputs)
};